import React, { useState } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { FiAward, FiRefreshCw } from 'react-icons/fi';

const Quiz = ({ questions, topicId, userId }) => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [showResult, setShowResult] = useState(false);
  const [score, setScore] = useState(0);
  const [answers, setAnswers] = useState([]);

  const handleAnswer = (answerIndex) => {
    setSelectedAnswer(answerIndex);
  };

  const handleNext = async () => {
    const isCorrect = selectedAnswer === questions[currentQuestion].correctAnswer;
    const newAnswers = [...answers, { question: currentQuestion, answer: selectedAnswer, correct: isCorrect }];
    setAnswers(newAnswers);

    if (isCorrect) {
      setScore(score + 1);
    }

    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setSelectedAnswer(null);
    } else {
      setShowResult(true);
      
      // Save quiz result to Firebase
      if (userId && topicId) {
        try {
          await setDoc(doc(db, 'quiz_results', userId, topicId, Date.now().toString()), {
            score: isCorrect ? score + 1 : score,
            total: questions.length,
            answers: newAnswers,
            timestamp: new Date()
          });
        } catch (error) {
          console.error('Error saving quiz result:', error);
        }
      }
    }
  };

  const handleReset = () => {
    setCurrentQuestion(0);
    setSelectedAnswer(null);
    setShowResult(false);
    setScore(0);
    setAnswers([]);
  };

  if (showResult) {
    const percentage = Math.round((score / questions.length) * 100);
    let message = '';
    let emoji = '';

    if (percentage >= 80) {
      message = 'Excellent! You\'re a champion! 🏆';
      emoji = '🎉';
    } else if (percentage >= 60) {
      message = 'Good job! Keep practicing! 👍';
      emoji = '😊';
    } else {
      message = 'Keep learning! You\'ll get there! 💪';
      emoji = '📚';
    }

    return (
      <div className="quiz-container">
        <div className="quiz-result">
          <div style={{ fontSize: '64px', marginBottom: '16px' }}>{emoji}</div>
          <div className="quiz-score">{score}/{questions.length}</div>
          <h3 style={{ fontSize: '24px', marginBottom: '8px' }}>{message}</h3>
          <p style={{ color: '#757575', marginBottom: '24px' }}>
            You scored {percentage}% on this quiz!
          </p>
          <button className="btn btn-primary" onClick={handleReset}>
            <FiRefreshCw /> Try Again
          </button>
        </div>
      </div>
    );
  }

  const question = questions[currentQuestion];

  return (
    <div className="quiz-container">
      <div className="quiz-header">
        <h3 className="quiz-title">
          <FiAward /> Test Your Knowledge
        </h3>
        <div className="quiz-progress">
          Question {currentQuestion + 1} of {questions.length}
        </div>
      </div>

      <div className="quiz-question">
        <p className="question-text">{question.question}</p>
        <div className="quiz-options">
          {question.options.map((option, index) => (
            <div
              key={index}
              className={`quiz-option ${selectedAnswer === index ? 'selected' : ''}`}
              onClick={() => handleAnswer(index)}
            >
              {option}
            </div>
          ))}
        </div>
      </div>

      <div className="quiz-actions">
        <div>
          {currentQuestion > 0 && (
            <button 
              className="btn btn-secondary"
              onClick={() => setCurrentQuestion(currentQuestion - 1)}
            >
              Previous
            </button>
          )}
        </div>
        <button 
          className="btn btn-primary"
          onClick={handleNext}
          disabled={selectedAnswer === null}
        >
          {currentQuestion === questions.length - 1 ? 'Finish' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default Quiz;

